var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "activationCode" } }, [
            _vm._v("设备激活码")
          ]),
          _c("el-menu-item", { attrs: { index: "competitionStudent" } }, [
            _vm._v("参赛学生")
          ]),
          _c("el-menu-item", { attrs: { index: "predeterStudent" } }, [
            _vm._v("内定学生")
          ]),
          _c("el-menu-item", { attrs: { index: "scoreList" } }, [
            _vm._v("成绩明细")
          ]),
          _c("el-menu-item", { attrs: { index: "winnerList" } }, [
            _vm._v("获奖列表")
          ])
        ],
        1
      ),
      _c("activationCode", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "activationCode",
            expression: "activeIndex == 'activationCode'"
          }
        ],
        ref: "activationCode",
        attrs: { eventId: _vm.eventId }
      }),
      _c("competitionStudent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "competitionStudent",
            expression: "activeIndex == 'competitionStudent'"
          }
        ],
        ref: "competitionStudent",
        attrs: { eventId: _vm.eventId }
      }),
      _c("predeterStudent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "predeterStudent",
            expression: "activeIndex == 'predeterStudent'"
          }
        ],
        ref: "predeterStudent",
        attrs: { eventId: _vm.eventId }
      }),
      _c("scoreList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "scoreList",
            expression: "activeIndex == 'scoreList'"
          }
        ],
        ref: "scoreList",
        attrs: { eventId: _vm.eventId }
      }),
      _c("winnerList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "winnerList",
            expression: "activeIndex == 'winnerList'"
          }
        ],
        ref: "winnerList",
        attrs: { eventId: _vm.eventId, eventStatus: _vm.eventStatus }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }